export default {
  //Finnish  Suomi/Suomi fi
LandingPage: {
  intro_sub:
    'Anna pakkaukselle uusi elämä',
  title: 'Samsungin pakkaukset',
  sequence1_1: 'Löydä uusia käyttötapoja pakkaukselle',
  sequence1_2:
    'Luo jotakin uutta television pakkauksesta. Katso alta miten se tapahtuu.',
  sequence2_1: 'Saammeko esitellä: Samsungin uudet pakkaukset',
  sequence2_2:
    'Televisiopakkaustemme ”upcycling”-ajattelu tarkoittaa, että pakkauksesta voidaan luoda uusia tuotteita.',
  sequence3_1: 'Noudata pakkauksen ohjeita',
  sequence3_2:
    'Leikkaa pakkaus ohjeiden mukaan ja kokoa siitä uusi tuote!',
  sequence4_1: 'Valitse, minkä tuotteen haluat tehdä',
  sequence4_2:
    'Selaa alas ja valitse oma TV-mallisi. Valitse sitten eri vaihtoehdoista ja luo pakkauksesta jotakin aivan uutta.',
  selectBox: 'Valitse televisiosi',
  moreActivity:
    "Lue lisää Samsungin kestävän kehityksen toimista",
  OLED: 'OLED',  
  QLED8K: 'QLED', //update
  UHD: 'Crstal UHD', //update
  theFrame: 'The Frame', //update
  theSerif: 'The Serif', //update
  theSero: 'The Sero', //update
  theTerrace: 'The Terrace', //update
  thePremiere: 'The Premiere', //update
  Monitors: 'Monitors', //update
  OdysseyArk:"Odyssey Ark",
  QSoundbar: 'Soundbar Q-Seria', //update
  Soundbar: 'Soundbar', //update
  SoundbarSet01:'Soundbar w zestawie 1',
  SoundbarSet02:'Soundbar w zestawie 2',
  TheTerraceSoundbar:'The Terrace Soundbar',
  Soundtower:'Sound Tower',
  BespokeJet: 'BESPOKE Jet\n (Jet)',
  BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
  BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
  BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
  BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
  BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
  BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
  BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
  Qooker:'Qooker',
  BespokeSlim:'BESPOKE Slim',
  TheFreeStyle:"The Freestyle",
  BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
  JetCleanStation:"Jet&\nClean Station™",
  JetCleanStation2:"Jet&Clean Station™",
  BlueSky:"BlueSky \n5500",
  BlueSky3000:"BlueSky \n3000",
  BlueSky3100:"BlueSky \n3100",
  BlueSky5000:"BlueSky \n5000",
  BespokeJetbot:"BESPOKE\n Jet Bot",
  BespokeJetbot2:"BESPOKE Jet Bot",
  BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
  BespokeJetbotPlus2:"BESPOKE Jet Bot+",
  BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
  BespokeJetbotAI2:"BESPOKE Jet Bot AI",
  Canister01:"Canister \n01",
  Canister02:"Canister \n02",
  Jupiter:"Vacuum \nCleaner",
  ref_cube:"BESPOKE Cube",
  WaterPurifier:"Water Purifier",
  LATIN:"LATIN",
  LATIN10:"LATIN10",
  MIRROR:"MIRROR",
  MW5100J:"MW5100J",
  STENA:"STENA",
  // moreActivityLink:
  //   'https://www.samsung.com/us/sustainability/overview/',
  moreActivityLink:'https://www.samsung.com/fi/aboutsamsung/sustainability/strategy/',
  footer: `
  Copyright© 2019-2021 Samsung. Kaikki oikeudet pidätetään.`,
},
ProductPage: {
  selectDesign: 'Valitse, minkä tuotteen haluat tehdä',
  selectDesignDezeen: 'Samsung X Dezeen', //update
  selectDesignSoccer: 'Samsung X Football', 
  tvConsole: 'TV-konsoli',
  StorageBox: 'Säilytyslaatikko',
  MagazineRack: 'Lehtihylly',
  CatHouse: 'Kissan talo',
  CatTunnel: 'Kissan tunneli',
  BookShelf: 'Kirjahylly',
  DeskShelf: 'Kirjoituspöydän hylly',
  BlackRhino: 'Uhanalaiset lajit\n – musta sarvikuono', //update
  PolarBear: 'Uhanalaiset lajit\n – jääkarhu', //update
  SeaTurtle: 'Uhanalaiset lajit\n – kilpikonna', //update
  TheRider: 'Keinuhevonen', //update
  Kibe: 'Kibe', //update
  Tessellate: 'Hylly', //update
  Twist: 'Twist-laatikko', //update
  AlexCouchArmTable: 'Alex-pöytä\n sohvan käsinojaan', //update
  BlastOffClubHouse: 'Rakettitalo', //update
  KinokoTable: 'Kinoko\n-pöytä', //update
  Magnuss: 'Magnuss\n-säilytyshylly', //update
  GIO: 'Ruukku', //update
  PostCardPlanter: 'Postikorttipidike', //update
  SneakerRack: 'Kenkähylly', //update
  TheSoban: 'Keittokirjan pidike', //update
  ToolBox: 'Työkalupakki', //update
  DeskStationary: 'Kirjoituspöydän\n hylly',
  CoinBank: 'Säästöpossu',
  MobileScanner:'Puhelimen\n skannausteline',
  TabletScanner:'Tabletin\n skannausteline',
  PetStairs:'Lemmikkirappu',
  PetFurniture:'Pet Freindly Furniture',
  ShoeRackA:'Shoe Rack_A',
  ShoeRackB:'Shoe Rack_B',
  WineRackDog:'Wine Rack Dog',
  WineRack:'Wine Rack',
  mins: 'minuuttia',
  all:'Kaikki ',
  in: 'tuumaa',
  inOnly: 'vain tuumaa',
  allBoxSize: 'Kaikki laatikkokoot',
  soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
},
DetailGuidePage: {
  1:'1',
  2:'2',
  3:'3',
  instructions: 'ohjeet',
  prepare: 'Valmistele pakkaus',
  LetsDesign: "Nyt suunnitellaan",
  drawParts: 'Piirrä osat pakkaukseen',
  note1: 'Ota huomioon, että grafiikan sijainti voi vaihdella maasta ja koosta riippuen',
  note2: 'Piirrä koko piirustus ensin ollaksesi varma, että se mahtuu kokonaisuudessaan pakkaukseen',
  numberSpace: 'numero = pisteiden välinen etäisyys',
  diagonal: 'diagonaalinen',
  LEFT: 'VASEN',
  RIGHT: 'OIKEA',
  TOP: 'YLÄPUOLI',
  TOP1: 'YLÄPUOLI 1',
  TOP2: 'YLÄPUOLI 2',
  BACK: 'TAKAOSA',
  MIDDLE: 'KESKIOSA',
  MIDDLE2: 'KESKIOSA 2',
  BOTTOM: 'POHJA',
  FRONT: 'ETUOSA',
  SIDE: 'SIVU',
  secondSIDE: 'TOINEN SIVU',
  secondSIDE1: 'TOINEN SIVU 1',
  secondSIDE2: 'TOINEN SIVU 2',
  LEG: 'JALAT', //update
  JOINT: 'LIITOS', //update
  FACE: 'KASVOT', //update
  DRAWERBOTTOM: 'LAATIKON POHJA', //update
  DRAWERSIDE: 'LAATIKON SIVU', //update
  NOSE: 'NENÄ', //update
  HANDLE: 'KÄDENSIJA', //update
  BOTTOMSIDE: 'POHJAPUOLI', //update
  TOPSIDE: 'YLÄPUOLI', //update
  WING: 'SIIPI', //update
  cutAndAssemble: "Aika leikata ja koota",
  beCareful: 'Ole varovainen leikatessasi, ettet satuta itseäsi',
  cutOutParts: 'Leikkaa osat erilleen',
  assemble: 'Kokoa',
  Assemblyguide: 'Kokoamisohje', //update
  fold: 'Esimerkki taitoksista',
  foldGuide: 'Käytä tuotteen reunaa taittaessasi pahvia',
  foldGuideDezeen:
    'Paina pakkauksen rei’itettyä viivaa muutaman kerran, niin pakkauksen taittaminen käy helpommin', //update
  glue: 'Käytä liimaa tai teippiä tasaisesti pinnalle', //update
  cable: 'Voit käyttää esimerkiksi nippusiteitä osien kiinnittämiseen', //update
  done: 'Valmis!',
  goBack: 'Takaisin päävalikkoon',
},
CautionPage: {
  CAUTION: 'VAROITUS',
  needItem: 'Tarvitset nämä esineet',
  children: 'Lasten tulee olla aikuisten seurassa',
  mat:
    'Aseta lattialle jokin suoja naarmujen ehkäisemiseksi',
  doNotPutHeavyThing:
    'Älä seiso tai istu näiden huonekalujen päällä, äläkä sijoita niihin liian painavia esineitä',
  doNotThrow:
    'Älä heitä tai potki huonekaluja mitään tai ketään kohti',
  stayAwayFlame: 'Pidä etäällä avotulesta',
  stayAwayWater: 'Pidä etäällä vedestä ja kosteudesta',
  mayDamaged: '*) TV-pakkaus on voinut vaurioitua kuljetuksen aikana',
  companyDoestResponsible:
    '*) Yritys ei ota vastuuta tämän työn aikana sattuneista onnettomuuksista tai vahingoista',
  cannotBeReturned:
    '*) Vaurioituneessa pakkauksessa olevia tuotteita ei voi palauttaa laatuseikkojen takia',
  understand: 'OK, ymmärrän',
},
PrivacyPolicy: {
  title: 'Yksityisyyden suoja',
},
GoingGreen: {
  visual: {
    title: 'Pakkausinnovaatiomme',
    text1:
      'Pyrimme käyttämään vähemmän paperia ja painomustetta useimmissa televisiopakkauksissamme (aiempiin pakkauksiimme verrattuna). ',
    text2:'',
    text2_special:
      '( *) Yllä mainittu ei koske tiettyjä malleja, kuten Lifestyle-TV-mallejamme)',
    text3: 'Valitse alla oleva painike, jos haluat lisätietoja',
  },
  greenIn: {
    title: 'Uudet pakkausinnovaatiot',
    subtitle1: 'Hae tuotetietoja',
    subtitle2: 'Pakkausten upcycling',
    desc: 'Etsi lisätietoja mallinimellä',
    descM: '*) Ota kuva television mallinumerosta',
    guide: 'mallin nimi',
    button: 'Ota kuva',
    button2: 'Siirry Luo tuotteita -sivulle',
    product_info: 'Tuotetiedot',
  },
  search: {
    guide: 'Haku...',
    noResult: 'Ei tuloksia',
    more: 'LISÄÄ',
    search: 'Haku',
    retake: 'Tee uudelleen',
    result: 'Tulokset',
  },
  photo: {
    guide1: 'Sijoita television mallinimi pakkaukseen',
    guide2: '(Esim. Q800A, UT7000, RU710)',
  },
},
searchCountrySelect: 'Valitse maa haun suorittamiseksi'
};
